import styled from "styled-components";

export const FreeSelectionRowContainer = styled.div`
    width: 100%;
    display: flex;
`;


// WEBPACK FOOTER //
// ./src/Components/Address/AddressRow/AddressRowStyle.js